/** Console native device directory (metering + sharing groups), English UI */
export default {
  deviceMenu: {
    meteringDivider: 'Metering Devices',
    sharingDivider: 'Device Sharing Groups',
    electricity: 'Electricity Meters',
    electricityDetail: 'Meter Details',
    water: 'Water Meters',
    waterDetail: 'Water Meter Details',
    hvac: 'HVAC',
    hvacDetail: 'HVAC Details',
    electricitySharing: 'Elec Sharing',
    electricitySharingDetail: 'Electricity Sharing Details',
    waterSharing: 'Water Sharing',
    waterSharingDetail: 'Water Sharing Details',
    hvacSharing: 'HVAC Sharing',
    hvacSharingDetail: 'HVAC Sharing Details'
  }
}
